<template>
  <div class="width-100" :class="{ error: errorMessage, success: fieldMeta.valid }">
    <InputGroup class="width-100">
      <Dropdown :id="name" :loading="loading" v-model="selectedId" :name="name" :options="optionList"
        :option-label="field || 'display_name'" option-value="id" :filter="showFilter"
        :placeholder="inputAttrs.placeholder" :class="['base w-full', { 'p-invalid': !!errorMessage }]"
        :disabled="disabled" v-bind="inputAttrs" @change="onChange" @filter="onFilter">
        <template #option="slotProps">
          <div class="autocomplete-list">
            <slot name="innerTPL" :slot-props="{ item: slotProps.option }">
              {{ slotProps.option.display_name }}
            </slot>
          </div>
        </template>
        <template #footer>
          <div class="flex justify-content-end mr-2 mb-1">
            <Button type="button" class="button-link" @click="addnew">
              <Icon type="favicon" icon="Plus" class="text-left" />
              <span class="ml-2">Add an {{ inputAttrs.name }}</span>
            </Button>
          </div>
        </template>
      </Dropdown>
      <InputGroupAddon v-if="showEditAddon" v-tooltip.bottom="'Click here to edit'" @click="onBtnEdit">
        <i class="pi pi-pencil cursor-pointer" />
      </InputGroupAddon>
    </InputGroup>
    <!-- {{ inputValue }} -->

    <!-- <span v-show="errorMessage" class="help-message">{{ errorMessage }}</span> -->
    <small v-if="errorMessage" class="p-error block mt-1">{{ errorMessage }}</small>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import { computed, getCurrentInstance, inject, ref, watch } from "vue";
import { getMyGemService } from "../../../services";

export default {
  inject: ["service", "meta"],
  props: {
    name: {
      type: String,
      required: true,
    },
    suggestions: {
      type: [String, Array],
      default: "",
    },
    items: {
      type: [String, Array],
      default: "",
    },

    modelValue: {
      type: [String, Number, Object],
      default: null,
    },
    className: {
      type: String,
      default: "",
    },
    field: {
      type: String,
      default: "",
    },
    dropdown: {
      type: Boolean,
      default: false,
    },
    optionGroupLabel: {
      type: String,
      default: "",
    },
    optionGroupChildren: {
      type: String,
      default: "",
    },
    inputAttrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    addon: {
      type: Boolean,
      default: true,
    },
    serviceId: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const meta = inject("meta", null);
    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const selectedId = ref(null);

    const optionList = computed(() =>
      Array.isArray(props.suggestions) ? props.suggestions : [],
    );

    const showFilter = computed(() => optionList.value.length > 9);

    const resolveId = (val) => {
      if (val && typeof val === "object") return val.id ?? null;
      return val ?? null;
    };
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta: fieldMeta,
      resetField,
    } = useField(props.name, undefined, {
      initialValue: resolveId(props.modelValue),
    });
    resetField({
      value: resolveId(props.modelValue),
    });
    selectedId.value = resolveId(props.modelValue);
    // watch(
    //   () => inputValue,
    //   (first, second) => {
    //     inputValue.value = first;
    //   },
    // );
    watch(
      () => [props.modelValue, optionList.value],
      () => {
        const id = resolveId(props.modelValue);
        selectedId.value = id;
        if (id != null && id !== "") {
          inputValue.value = id;
          handleChange(id);
        }
      },
      { immediate: true }
    );

    function onChange(event) {
      const option = optionList.value.find((o) => o.id == event.value);
      emit("update:modelValue", option ?? event.value);
      emit("change", { ...event, value: option ?? event.value });
      inputValue.value = event.value;
      handleChange(event.value);
    }
    function onFilter(event) {
      emit("auto-complete", { query: event.value });
    }

    function addnew() {
      emit("btn-create");
    }
    function onBtnEdit() {
      const id = selectedId.value;
      if (!props.serviceId) {
        emit("btn-edit", { id });
        return;
      }
      const servicebyDomian = getMyGemService(props.serviceId);
      const { emitter, $t } = getCurrentInstance().proxy;
      emitter.emit("open-gem", {
        item: {
          key: "edit",
          label: $t("edit"),
          isVisible: true,
          service: servicebyDomian,
          parent: meta?.windowIndex,
          domain: meta?.service?.DOMAIN,
          item: { id },
          cb: (event) => {
            if (event.meta.service.DOMAIN == props.serviceId) {
              const list = Array.isArray(props.suggestions) ? props.suggestions : [];
              const find = list.find((value) => value.id == event.data.id);
              if (!find) return;
              Object.entries(event.data).forEach(([key, value]) => {
                find[key] = value;
              });
              if (event.data.status == 0) {
                find.display_name = find.display_name.concat(" (INACTIVE)");
              }
              emit("changeById", find);
            }
          },
        },
      });
    }
    const showEditAddon = computed(() => {
      if (!props.addon || props.disabled) return false;
      const id = selectedId.value;
      if (id == null || id === "" || !(Number(id) > 0)) return false;
      return meta?.mode === "edit";
    });
    return {
      handleChange,
      errorMessage,
      inputValue,
      selectedId,
      optionList,
      showFilter,
      onChange,
      onFilter,
      addnew,
      onBtnEdit,
      showEditAddon,
      fieldMeta,
      loading: computed(() => props.loading),
    };
  },
};
</script>

<style>
div.p-error input:focus {
  border-color: var(--error-color);
}

div.has-error .p-error {
  color: var(--error-color);
}

.base.p-inputgroup .inputtext,
.fluid .p-inputgroup .inputtext,
.p-inputgroup .inputwrapper,
.fluid .p-inputgroup .input {
  flex: 1 1 auto;
  width: 100% !important;
  border-color: red;
}
</style>
